import Api from '../api';
const { axios: api } = Api;
const PREFIX = 'payment';

export const createOneOffPayment = async (payload) => {
	const data = await api.post(`/${PREFIX}/create-one-off-payment`, payload);
	return { data: data.data };
};

export const createSubscriptionPayment = async (payload) => {
	const data = await api.post(
		`/${PREFIX}/create-subscription-payment`,
		payload,
	);
	return { data: data.data };
};

export const checkQuizOrderStatus = async ({ email, paymentIntent }) => {
	const params = new URLSearchParams({ email });

	if (paymentIntent) {
		params.set('paymentIntent', paymentIntent);
	}

	const data = await api.get(
		`/${PREFIX}/check-quiz-order-status?${params.toString()}`,
	);
	return { data: data.data };
};
